export enum ImageGroupId {
    JourneySetIcon = "cc61a205-70f7-4b8c-92a0-0a4ea2b93f21",
    JourneyImages = "cc61a205-70f7-4b8c-92a0-0a4ea2b93f21"
    //JourneyImages = "b7bb76e2-9661-4640-b64f-497d285cf494"
}

export const IMAGE_GROUP_TYPES = new Map<string, string>([
    [ImageGroupId.JourneySetIcon, "set in setEnumValues()"],
    [ImageGroupId.JourneyImages, "set in setEnumValues()"]
]);